<label
  ui-checkbox
  class="ant-checkbox-group-item"
  *ngFor="let o of options; trackBy: trackByOption"
  [uiDisabled]="o.disabled || nzDisabled"
  [uiChecked]="o.checked!"
  (uiCheckedChange)="onCheckedChange(o, $event)">
  <span>{{ o.label }}</span>
</label>
